import $ from "jquery";


$(document).ready(function () {
	$('.menu__item--has-children').on('mouseenter', function () {
		$(this).find('ul').css({
			'opacity': '1',
			'transform': 'translateY(0)',
			'transition-delay': '0' 

		});
	});

	$('.menu__item--has-children').on('mouseleave', function () {
		$(this).find('ul').css({
			'opacity': '0',
			'transform': 'translateY(-10px)',
			'transition-delay': '0.5s', 
		});
	});
});
